import Head from 'next/head';

function strip(html) {
  const one = html.replace(/<\/?[^>]+(>|$)/gm, '');
  const two = one.replace(/[\r\n]\s*[\r\n]/gm, '');
  return two;
}

function formatIfArray(value) {
  return Array.isArray(value)
    ? '[' +
        value.map(function (val) {
          return '"' + val + '"';
        }) +
        ']'
    : '"' + value + '"';
}

function buildBrand(brand) {
  return (
    '\n  "brand": {\n      "@type": "BRAND",\n      "name": "' +
    brand +
    '"\n    },\n'
  );
}

function buildOffers(offers) {
  return (
    '\n  {\n    "@type": "Offer",\n    "priceCurrency": "' +
    offers.priceCurrency +
    '",\n    ' +
    (offers.priceValidUntil
      ? '"priceValidUntil": "' + offers.priceValidUntil + '",'
      : '') +
    '\n    ' +
    (offers.itemCondition
      ? '"itemCondition": "' + offers.itemCondition + '",'
      : '') +
    '\n    ' +
    (offers.availability
      ? '"availability": "' + offers.availability + '",'
      : '') +
    '\n    ' +
    (offers.url ? '"url": "' + offers.url + '",' : '') +
    '\n    ' +
    (offers.seller
      ? '\n      "seller": {\n      "@type": "Organization",\n      "name": "' +
        offers.seller.name +
        '"\n    },\n    '
      : '') +
    '\n    "price": "' +
    offers.price +
    '"\n  }\n'
  );
}

function buildOffers2(offers) {
  let arr = [];
  offers.map((ele, index) => {
    let obj = {
      '@type': 'Offer',
      priceCurrency: ele.priceCurrency,
      price: ele.price,
    };
    if (ele.priceValidUntil) {
      obj['priceValidUntil'] = ele.priceValidUntil;
    }
    if (ele.itemCondition) {
      obj['itemCondition'] = ele.itemCondition;
    }
    if (ele.availability) {
      obj['availability'] = ele.availability;
    }
    if (ele.url) {
      obj['url'] = ele.url;
    }
    if (ele.seller) {
      obj['seller'] = {
        '@type': 'Organization',
        name: ele.seller.name,
      };
    }

    arr.push(obj);
  });
  return arr;
}

function markup(jsonld) {
  return {
    __html: jsonld,
  };
}

function makeNftSchema(nftData, musicData, offers) {
  let schemaObj = {
    '@context': 'https://schema.org/',
    '@type': 'Product',
    name: nftData.tokenName,
  };

  if (nftData?.stasTokenImgArr1500?.length) {
    schemaObj['image'] = nftData?.stasTokenImgArr1500;
  }
  if (nftData.tokenDescription) {
    schemaObj['description'] = strip(nftData.tokenDescription);
  }
  if (nftData.tokenId) {
    schemaObj['sku'] = nftData.tokenId;
  }
  if (musicData?.name) {
    schemaObj['brand'] = {
      '@type': 'BRAND',
      name: musicData?.name,
    };
  }
  if (nftData?.creationDate) {
    schemaObj['releaseDate'] = new Date(
      Number(nftData.creationDate),
    ).toISOString();
  }
  if (nftData?.ownerName) {
    schemaObj['manufacturer'] = {
      '@type': 'Organization',
      name: nftData.ownerName,
    };

    if (nftData?.ownerImage) {
      schemaObj.manufacturer.logo = { '@type': 'ImageObject' };
    }
  }
  if (offers) {
    schemaObj['offers'] = buildOffers2(
      Array.isArray(offers) ? offers : [offers],
    );
  }

  console.log('schemaObj', JSON.stringify(schemaObj));

  // let res =
  //   '{\n    "@context": "https://schema.org/",\n    "@type": "Product",\n    ' +
  //   (nftData?.stasTokenImgArr1500?.length
  //     ? '"image":' + formatIfArray(nftData?.stasTokenImgArr1500) + ','
  //     : '') +
  //   '\n    ' +
  //   (nftData.tokenDescription
  //     ? '"description": "' + strip(nftData.tokenDescription) + '",'
  //     : '') +
  //   '\n    ' +
  //   (nftData.tokenId ? '"sku": "' + nftData.tokenId + '",' : '') +
  //   '\n    ' +
  //   (musicData?.name ? buildBrand(musicData?.name) : '') +
  //   '\n    ' +
  //   (nftData?.creationDate
  //     ? '"releaseDate": "' +
  //       new Date(Number(nftData.creationDate)).toISOString() +
  //       '",'
  //     : '') +
  //   '\n    ' +
  //   (nftData?.ownerName
  //     ? '\n        "manufacturer": {\n          "@type": "Organization",\n          ' +
  //       (nftData?.ownerImage
  //         ? '\n              "logo": {\n                "@type": "ImageObject",\n                "url": "' +
  //           nftData.ownerImage +
  //           '"\n              },\n              '
  //         : '') +
  //       '\n          "name": "' +
  //       nftData.ownerName +
  //       '"\n        },\n        '
  //     : '') +
  //   '\n    ' +
  //   (offers
  //     ? '"offers": ' +
  //       (Array.isArray(offers)
  //         ? '[' +
  //           offers.map(function (offer) {
  //             return '' + buildOffers(offer);
  //           }) +
  //           ']'
  //         : buildOffers(offers)) +
  //       ','
  //     : '') +
  //   '\n    "name": "' +
  //   nftData.tokenName +
  //   '"\n  }';

  // console.log('res', res);
  return JSON.stringify(schemaObj);
}

const NftSchema = (props) => {
  const { nftData, musicData, offers } = props;

  return (
    <Head>
      <script
        type="application/ld+json"
        key={`jobJSON-${nftData.tokenId}`}
        dangerouslySetInnerHTML={markup(
          makeNftSchema(nftData, musicData, offers),
        )}
      />
    </Head>
  );
};

export default NftSchema;
